import makePendingActions from '../../../oldpantheon/redux/pending/actions/makePendingActions';

const pantheonActions = makePendingActions();

export default {
  ...pantheonActions,
};
